module.exports = __webpack_public_path__ + "img/rs_blackP-patch2.a7712fe.png";